import React from "react";
import imagesLogo from "../landing-page/images/logo.svg";
import "../landing-page/css/style.css";

const Header = () => {
  return (
    <header>
      <div className="fixed-wrapper">
        <a href="#">
          <img src={imagesLogo} alt="" />
        </a>
      </div>
    </header>
  );
};

export default Header;
